module.exports = __webpack_public_path__ + "img/formatador_unico_icon.9842c066.svg";